module.exports = __webpack_public_path__ + "9cf4a9494005a3a233bb2fd3b9cfa14e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-good-morning.png
// module id = 2063
// module chunks = 4